import styled from 'styled-components';

export const Wrapper = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  &:not(:last-of-type) {
    padding-bottom: ${({ theme }) => theme.space[6]}px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.gray.extraLight};
  }
  &:not(:first-of-type) {
    padding-top: ${({ theme }) => theme.space[6]}px;
  }
`;
